import React from 'react'
import { Link } from 'react-router-dom'
import { Motion, spring, presets } from 'react-motion'

import IconClose from './IconClose'
import styles from './styles'

const Overlay = ({ toggleOverlay }) => (
	<Motion
		defaultStyle={{ opacity: 0 }}
		style={{ opacity: spring(1, presets.stiff) }}
	>
		{({ opacity }) => (
			<div style={{ ...styles.container, opacity }}>
				<IconClose
					onClick={toggleOverlay.bind(null, false)}
					style={styles.icon}
				/>
				<Link to="/about" onClick={toggleOverlay.bind(null, false)}>
					About
				</Link>
				<Link to="/media" onClick={toggleOverlay.bind(null, false)}>
					Media
				</Link>
				<Link to="/contact" onClick={toggleOverlay.bind(null, false)}>
					Contact
				</Link>
			</div>
		)}
	</Motion>
)

export default Overlay



// WEBPACK FOOTER //
// ./src/components/Layout/nav/MobileNav/Overlay/index.js